<template>
    <div class="editCertification">
        <el-alert
            v-if="data.is_apply === 3"
            :closable="false"
            :title="'审核拒绝，拒绝理由:' + data ? data.reject_reason : ''"
            type="error">
        </el-alert>
        <el-alert
            v-if="data.is_apply === 5"
            :closable="false"
            title="证件过期"
            type="warning">
        </el-alert>
        <div class="title">一、填写认证信息</div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="企业名称" prop="corporate_name">
                        <el-input v-model="ruleForm.corporate_name"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="企业类型" prop="corporate_type">
                        <el-input v-model="ruleForm.corporate_type"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="企业法人" prop="legal_person">
                        <el-input v-model="ruleForm.legal_person"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="法人身份证" prop="legal_person_card_id">
                        <el-input v-model="ruleForm.legal_person_card_id"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="法人身份过期时间" prop="legal_person_card_id_expires_time">
                        <el-date-picker style="width: 100%" type="date" value-format="yyyy-MM-dd" v-model="ruleForm.legal_person_card_id_expires_time"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="公司联系人" prop="contacts">
                        <el-input v-model="ruleForm.contacts"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="联系人手机" prop="mobile">
                        <el-input v-model="ruleForm.mobile"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="固定电话" prop="tel_phone">
                        <el-input v-model="ruleForm.tel_phone"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="所在地区" required>
                <el-col :span='24'>
                    <el-form-item prop="city">
                        <el-cascader v-model="ruleForm.city" @change="addressChange" :props="cascaderProps" style="width: 60%"></el-cascader>
                    </el-form-item>
                </el-col>
            </el-form-item>
            <el-form-item label="详细地址" prop="address">
                <el-input type="textarea" v-model="ruleForm.address" auto-complete="off" style="width:653px;"></el-input>
            </el-form-item>
        </el-form>
        <div class="title">二、上传资质信息</div>
        <div class="PS">
            请添加药品经营许可证、GSP证、营业执照、质保书、采购&收货授权委托书、身份证复印件、组织机构代码证税务登记证、医疗机构许可证
        </div>
        <div class="imgBox">
            <AppForm
                ref="form3"
                hiddenBtns
                v-if="showCertificate"
                formStyle="default"
                :rules="rules3"
                :defaultValues="defaultValues3"
                :fields="formFieldsImages"/>
            <div style="width：300px;margin:0 auto;">
                <!-- <el-button type="primary" style="margin: 0 auto;margin-right:15px;" @click="save">保存</el-button> -->
                <el-button type="primary" style="margin: 0 auto;" @click="submit">提交审核</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { UserCenterService } from '../../../service/userCenter.service'
// import  APPupload  from '@/components/upload'
import AppForm from '../../../components/form/form.component.vue';
import moment from 'moment';
import { Message } from 'element-ui';
const rules3 = {
    management_license: [{ required: true, message: '请选择图片'}],
    management_license_expires_time: [{ required: true, message: '请填写有效期'}],
    business_license: [{ required: true, message: '请选择图片'}],
    business_license_expires_time: [{ required: true, message: '请填写有效期'}],
    gps_license: [{ required: true, message: '请选择图片'}],
    gps_license_expires_time: [{ required: true, message: '请填写有效期'}],
    warranty_book: [{ required: true, message: '请选择图片'}],
    warranty_book_expires_time: [{ required: true, message: '请填写有效期'}],
    authorised_letter: [{ required: true, message: '请选择图片'}],
    authorised_letter_expires_time: [{ required: true, message: '请填写有效期'}],
    id_copy: [{ required: true, message: '请选择图片'}],
    id_copy_expires_time: [{ required: true, message: '请填写有效期'}],
    tax_certificate: [{ required: true, message: '请选择图片'}],
    tax_certificate_expires_time: [{ required: true, message: '请填写有效期'}],
    medical_license: [{ required: true, message: '请选择图片'}],
    medical_license_expires_time: [{ required: true, message: '请填写有效期'}],
    legal_person_card_id_expires_time: [{ required: true, message: '请填写有效期'}],
};
const formFieldsImages = [
  { type: 'image', key: 'management_license', label: '药品经营许可证', limit: 1, pathType: 'certificate', span: 6, height: '190px' },
  { type: 'date', key: 'management_license_expires_time', label: '药品经营许可证有效期', height: '190px', span: 6 },
  { type: 'image', key: 'business_license', label: '营业执照', limit: 1, span: 6, pathType: 'certificate', height: '190px' },
  { type: 'date', key: 'business_license_expires_time', label: '营业执照有效期', height: '190px', span: 6 },
  { type: 'image', key: 'gps_license', label: '	GPS证', limit: 1, span: 6, pathType: 'certificate' , height: '190px'},
  { type: 'date', key: 'gps_license_expires_time', label: 'GPS证有效期', height: '190px', span: 6 },
  { type: 'image', key: 'warranty_book', label: '质保书', limit: 1, span: 6, pathType: 'certificate', height: '190px' },
  { type: 'date', key: 'warranty_book_expires_time', label: '质保书有效期', height: '190px', span: 6 },
  { type: 'image', key: 'authorised_letter', label: '采购&收货授权委托书', limit: 1, span: 6, pathType: 'certificate', height: '190px' },
  { type: 'date', key: 'authorised_letter_expires_time', label: '采购&收货授权委托书有效期', height: '190px', span: 6 },
  { type: 'image', key: 'id_copy', label: '需附身份证复印件', limit: 1, span: 6, pathType: 'certificate', height: '190px' },
  { type: 'date', key: 'id_copy_expires_time', label: '需附身份证复印件有效期', height: '190px', span: 6 },
  { type: 'image', key: 'tax_certificate', label: '组织机构代码证税务登记证', limit: 1, span: 6, pathType: 'certificate', height: '190px' },
  { type: 'date', key: 'tax_certificate_expires_time', label: '组织机构代码证税务登记证有效期', height: '190px', span: 6 },
  { type: 'image', key: 'medical_license', label: '医疗机构许可证', limit: 1, span: 6, pathType: 'certificate', height: '190px' },
  { type: 'date', key: 'medical_license_expires_time', label: '医疗机构许可证有效期', height: '190px', span: 6 },
];
export default {
    components: { AppForm },
    props: [ 'data', 'isApply' ],
    data() {
        var checkCorporate_name = (rule,value,callback) => {
          if(!value) {
            return callback(new Error('身份证号码不能为空'))
          }else {
            var corporate_name = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
            if(corporate_name.test(value)) {
              callback()
            }else {
              return callback(new Error('身份证号码不合法'))
            }
          }
        }
        var checkPhone = (rule, value, callback) => {
          if (!value) {
              return callback(new Error('手机号不能为空'));
          } else {
                const reg = /^1[3456789]\d{9}$/
                if (reg.test(value)) {
                    callback();
                } else {
                    return callback(new Error('请输入正确的手机号'));
                }
            }
        }
        var addressVaildator = (rule, v, callback) => {
        const value = this.ruleForm.city;
          if (!value) {
              return callback(new Error('请选择地址'));
          } else {
                if (value && value.length > 0) {
                    callback();
                } else {
                    return callback(new Error('请选择地址'));
                }
            }
        }
        var tel = (rule, value, callback) => {
            if(value){
                const reg = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,8}$/
                if (reg.test(value)) {
                    callback();
                } else {
                    return callback(new Error('请输入正确的座机号码'));
                }
            }else{
                callback()
            }
        }
        const cascaderProps = {
          lazy: true,
          lazyLoad: async (node, resolve) => {
            const { level } = node;
            const data = await this.getArea(level + 1, node.value || 0);
            const nodes = data.map(item => ({
                value: item.id,
                label: item.name,
                leaf: level >= 3
            }));
              resolve(nodes);
          }
        }
        return {
            rules3,
            defaultValues3: {},
            formFieldsImages,
            cascaderProps,
            province: [],
            city: [],
            district: [],
            twon: [],
            fileList: [],
            showCertificate: false,
            ruleForm: {
                city: [],
            },
            rules: {
                corporate_name: [{ required: true, message: '请输入企业名称' }],
                corporate_type: [{ required: true, message: '请选择企业类型' }],
                legal_person: [ { required: true, message: '请输入法人名称' } ],
                legal_person_card_id: [ { validator: checkCorporate_name, required: true }],
                contacts: [{ required: true, message: '请输入联系人名称' } ],
                mobile: [ { validator: checkPhone, required: true }],
                tel_phone: [ { validator: tel }, { required: true, message: '请输入固话' }],
                // province: [{ required: true, message: '请选择地址', trigger: 'change'}],
                city: [ { validator: addressVaildator }],
                legal_person_card_id_expires_time: [ { required: true, message: '请选择过期时间' } ],
                // district: [{ required: true, message: '请选择地址', trigger: 'change'}],
                address: [ { required: true, message: '请填写详细地址', trigger: 'change'}]
            }
        }
    },
    methods: {
        async getArea(level,id) {
            const data = await UserCenterService.getArea(level,id)
            return Promise.resolve(data);
        },
        addressChange(value) {
            this.ruleForm.city = value;
            this.$refs.ruleForm.validateField('city');
        },
        selectChange() {
            this.$forceUpdate()
        },
        save() {
          this.$refs.ruleForm.validate((valid) => {
            if (valid) {
                delete this.ruleForm.base_url
                delete this.ruleForm.is_apply
                UserCenterService.userCertificatesSave(this.ruleForm)
            } else {
                console.log('error submit!!');
                return false;
            }
          })
        },
        async submit() {
            const form3Data = await this.$refs.form3.submit();
            const imagesData = { ...form3Data };
            for (const key of Object.keys(imagesData)) {
                if(imagesData[key] instanceof Array) {
                    imagesData[key] = UserCenterService.eliminateImg(imagesData[key][0].url);
                } else {
                    imagesData[key] = moment(imagesData[key]).format('YYYY-MM-DD');
                }
            }
            const data2 = {};
            for (const key of Object.keys(this.ruleForm)) {
                if(this.ruleForm[key]) {
                    data2[key] = this.ruleForm[key];
                }
            }
            delete data2.base_url;
            this.$refs.ruleForm.validate(async (error) => {
                const data = { ...data2 };
                delete data.is_apply;
                delete data.reject_reason;
                if (form3Data && error) {
                    data.province = data.city[0];
                    data.district = data.city[2];
                    data.town = data.city[3];
                    data.city = data.city[1];
                    await UserCenterService.userCertificatesSave({...data, ...imagesData});
                    await UserCenterService.userSubmit();
                    Message.success('提交成功');
                    this.$emit('submit',2);
                }
            })
            // console.log(data);
            // this.$confirm('此操作将提交保存的内容，请先确认已经保存了审核所需的信息','提示',{
            //     confirmButtonText:'确定',
            //     cancelButtonText: '取消',
            //     type: 'warning'
            // }).then(()=>{
                // this.$emit('submit',2)
            // })
        },
        initialize(certificatedata) {
            if (typeof certificatedata.is_apply === 'number' && certificatedata.is_apply !== 0) {
                const certificate = JSON.parse(JSON.stringify(certificatedata))
                const formdefaultValue = {};
                this.formFieldsImages.forEach(item => {
                    if (certificate[item.key]) {
                        if (item.key.includes('_expires_time')) {
                            certificate[item.key] = moment(certificate[item.key]).toDate();
                        } else {
                            certificate[item.key] = [
                                {
                                    uid: item.key,
                                    name: '图片异常',
                                    status: 'done',
                                    url: UserCenterService.spliceImg(certificate[item.key])
                                }
                            ]
                        }
                        formdefaultValue[item.key] = certificate[item.key];
                    }
                });
                certificate.city = [certificate.province, certificate.city, certificate.district, certificate.town];
                this.defaultValues3 = formdefaultValue;
                this.showCertificate = true;
                this.ruleForm = certificate;
            } else if (typeof certificatedata.is_apply === 'number') {
                this.defaultValues3 = {};
                this.showCertificate = true;
                this.ruleForm = {
                    city: []
                };
            }
        }
    },
    watch: {
        data(newValue) {
            this.initialize(newValue);
            return newValue;
        }
    },
    async created() {
        this.initialize(this.data);
    }
}
</script>

<style lang="scss" scoped>
    .title{
        font-size: 15px;
        font-weight: 700;
        margin-top: 60px;
    }
    .PS{
        width: 90%;
        font-size: 14px;
        border: 1px solid #b9b9b9;
        border-radius: 2px;
        padding: 15px;
        margin: 60px auto;

    }
    .imgBox{
        display: inline-flex;
        flex-wrap: wrap;
        justify-content: space-between;
        text-align: center;
        height: auto !important;
        .imgItem{
            display: flex;
            flex-direction: column;
            height: 450px;
        }
    }
</style>

<style lang="scss">
    .uploadDisplay .el-upload--picture-card{
        display: none;
    }
</style>